import gql from 'graphql-tag'
import client from '@stores/apollo'
import { FetchResult } from 'apollo-link'

type InputType = {
  floorId: string
  enforceQrCode: boolean
}

type PayloadType = {
  floor: {
    enforceQrCode: boolean
  }
}

type UpdateEnforceQrCodeType = (input: InputType) => Promise<FetchResult<PayloadType>>

const updateEnforceQrCode: UpdateEnforceQrCodeType = ({ floorId, enforceQrCode }: InputType) => {
  return client.gql.mutate({
    mutation,
    variables: { input: { id: floorId, enforceQrCode } },
  })
}

const mutation = gql`
  mutation updateEnforceQrCode($input: UpdateFloorInput!) {
    updateFloor(input: $input) {
      floor {
        enforceQrCode
      }
    }
  }
`

export default updateEnforceQrCode
